import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';

import { mutation as updatePipelineMutation } from './update-pipeline-mutation-builder';
import { buildVariables as buildUpdatePipelineVariables } from './update-pipeline-mutation-builder';
import { PIPELINES_QUERY } from 'api/pipelines/pipelines-query-builder';

export default function useUpdatePipeline(options = {}) {
  const [executeMutation, response] = useMutation(updatePipelineMutation, {
    successMsg: 'Pipeline updated.',
    context: { permission: permissions.updatePipeline },
    refetchQueries: [PIPELINES_QUERY],
    ...options,
  });
  const updatePipeline = ({ pipelineId, name }) => {
    const variables = buildVariables({ pipelineId, name });
    return executeMutation(variables);
  };

  return [updatePipeline, response];
}

export function buildVariables({ pipelineId, name }) {
  return {
    variables: buildUpdatePipelineVariables({ pipelineId, name }),
  };
}
